// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spearow: PokeData = {
  "id": 21,
  "name": "spearow",
  "height": 3,
  "weight": 20,
  "base_experience": 52,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "fury-attack",
    "take-down",
    "leer",
    "growl",
    "peck",
    "drill-peck",
    "agility",
    "focus-energy",
    "mirror-move",
    "pursuit",
    "aerial-ace",
    "roost",
    "assurance"
  ],
  "moves": [
    "leer",
    "growl",
    "peck",
    "pursuit",
    "aerial-ace",
    "roost",
    "tri-attack",
    "protect",
    "quick-attack",
    "chatter",
    "hurricane",
    "refresh",
    "tackle"
  ],
  "evolution_chain": {
    "id": 8,
    "item": null,
    "species": [
      {
        "name": "spearow",
        "order": 21,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "fearow",
        "order": 22,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 21,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35.25,
    "speed": 70,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
